import { render, staticRenderFns } from "./ProfileDevice.vue?vue&type=template&id=01dc971e&scoped=true&"
import script from "./ProfileDevice.vue?vue&type=script&lang=js&"
export * from "./ProfileDevice.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDevice.vue?vue&type=style&index=0&id=01dc971e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dc971e",
  null
  
)

export default component.exports